import { showToast } from '@app/actions/toasts';

export default class NotificationManager {
  constructor(store) {
    this.store = store;
  }

  notify(message) {
    this.store.dispatch(showToast(message));
  }

  success(message) {
    this.store.dispatch(showToast(message));
  }

  error(message) {
    this.store.dispatch(showToast(message, { type: 'cancel' }));
  }
}



// WEBPACK FOOTER //
// ./src/infrastructure/NotificationManager.js